// eslint-disable-next-line @typescript-eslint/prefer-as-const
export const TOASTER_CATEGORY_KEY = 'portal' as const;
// eslint-disable-next-line @typescript-eslint/prefer-as-const
export const TOASTER_COMPONENT_KEY = 'toaster' as const;
